import Component from 'umg-ember-backend/components/record-explorer';

export default class RecordExplorerForArtistComponent extends Component {
  // Defaults
  availableFilters = [
    ...this.defaultFilters,
    {
      key: 'themeType',
      type: 'selectValueLabel',
      options: ['contributor', 'project', 'serie'],
    },
  ];

  defaultColumns = [
    'id',
    'screenname',
    'connectArtistInfo',
    'cmsState',
    'cmsModified',
  ];

  tableColumns = [
    {
      property: 'id',
      sortable: true,
    },
    {
      property: 'screenname',
      sortable: true,
      isMainColumn: true,
    },
    {
      property: 'connectArtistInfo',
    },
    {
      property: 'cmsLanguageId',
      type: 'translate-value',
    },
    {
      property: 'cmsState',
      sortable: true,
      type: 'translate-value',
      align: 'right',
    },
    {
      property: 'cmsModified',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
  ];
}
